import { Capacitor } from '@capacitor/core';
import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';

// Thin, crash-proof wrapper around Capacitor Haptics. No-ops on web/PWA and
// swallows every error so a haptic call can never break an interaction. Use
// these liberally on taps, swipes, correct/incorrect answers, and milestones
// to make the app feel physical. See lib/motion.tsx for the visual layer.

const native = () => Capacitor.isNativePlatform();

export const haptic = {
  /** Light tap — buttons, toggles, selection. */
  light() { if (native()) Haptics.impact({ style: ImpactStyle.Light }).catch(() => {}); },
  /** Medium tap — confirmations, opening sheets. */
  medium() { if (native()) Haptics.impact({ style: ImpactStyle.Medium }).catch(() => {}); },
  /** Heavy tap — big moments, swipe commit. */
  heavy() { if (native()) Haptics.impact({ style: ImpactStyle.Heavy }).catch(() => {}); },
  /** Success notification buzz — correct answer, level up, streak. */
  success() { if (native()) Haptics.notification({ type: NotificationType.Success }).catch(() => {}); },
  /** Warning buzz — mark-for-review, soft error. */
  warning() { if (native()) Haptics.notification({ type: NotificationType.Warning }).catch(() => {}); },
  /** Error buzz — wrong answer, failed action. */
  error() { if (native()) Haptics.notification({ type: NotificationType.Error }).catch(() => {}); },
  /** Selection tick — scrolling through options. */
  selection() { if (native()) Haptics.impact({ style: ImpactStyle.Light }).catch(() => {}); },
};
